"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../../config");
/**
 * Checkbox override.
 */
// tslint:disable-next-line:variable-name
var CheckBox = function (props) {
    var value = props.value, onChange = props.onChange, className = props.className, ownLabel = props.ownLabel, disabled = props.disabled;
    var b = config_1.block("input_checkbox");
    var outputClassName = b({ checked: value, unchecked: !value, disabled: disabled }).mix(className);
    var ret = react_1.default.createElement("span", { className: outputClassName, onClick: disabled ? undefined : onChange });
    if (ownLabel) {
        ret = (react_1.default.createElement("span", { className: b("label", { disabled: disabled }) },
            ret,
            react_1.default.createElement("label", { onClick: disabled ? undefined : onChange }, ownLabel)));
    }
    return ret;
};
exports.default = CheckBox;
//# sourceMappingURL=index.js.map